import React, { useCallback, useState } from "react";
import styled from "styled-components";

import { useAdminScope } from "../../../context/AdminScopeContext";
import { getAdminPanelConfig } from "./registry";
import AdminPanelErrorBoundary from "./AdminPanelErrorBoundary";
import PanelHeaderEngine from "./PanelHeaderEngine";
import { PanelActionsProvider } from "./PanelActionsContext";
import { PanelServicesProvider } from "./PanelServicesContext";

export default function AdminPanelRenderer({
  panelMode,
  panelKey,
  isFullscreen = false,
  onToggleFullscreen,
  onClose,
}) {
  const [businessActions, setBusinessActions] = useState([]);
  const config = getAdminPanelConfig(panelMode);

  const {
    selectedCompanyUuid,
    selectedCompanyName,
    selectedActivityUuid,
  } = useAdminScope();

  const registerActions = useCallback((actions) => {
    setBusinessActions(actions);
  }, []);

  if (!config) {
    return null;
  }

  const PanelComponent = config.component;
  const componentProps = config.props || {};

  const studioProps = (
    typeof config.loadStudioComponent === "function"
  )
    ? {
        ...(componentProps.studioProps || {}),
        companyUuid:
          selectedCompanyUuid || null,
        companyName:
          selectedCompanyName || null,
        activityUuid:
          selectedActivityUuid || null,
      }
    : null;

  return (
    <PanelRoot>
      <PanelHeaderEngine
        title={config.title}
        description={config.description}
        actions={businessActions}
        isFullscreen={isFullscreen}
        onToggleFullscreen={onToggleFullscreen}
        onClose={onClose}
      />

      <AdminPanelErrorBoundary
        key={`boundary-${panelMode}-${panelKey}`}
        panelMode={panelMode}
        panelKey={panelKey}
        panelTitle={config.title}
        onClose={onClose}
      >
        <PanelServicesProvider>
          <PanelActionsProvider registerActions={registerActions}>
            <PanelComponent
              key={`${config.keyPrefix || panelMode}-${panelKey}`}
              {...componentProps}
              {...(
                studioProps
                  ? {
                      loadStudioComponent:
                        config.loadStudioComponent,
                      studioProps,
                      isFullscreen,
                    }
                  : {}
              )}
            />
          </PanelActionsProvider>
        </PanelServicesProvider>
      </AdminPanelErrorBoundary>
    </PanelRoot>
  );
}

const PanelRoot = styled.div`
  min-width: 0;
  color: #f7f7f7;
`;
